/* assets/custom-collection-tabs.js */

document.addEventListener('DOMContentLoaded', () => {
  initCollectionTabs();
});

// Re-initialize for Shopify Theme Editor sections/blocks changes preview
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('custom-collection-tabs-container') || event.target.querySelector('.custom-collection-tabs-container')) {
    initCollectionTabs();
  }
});

// Handle block selection in the theme customizer to focus that tab
document.addEventListener('shopify:block:select', (event) => {
  const blockId = event.detail.blockId;
  const tabButton = document.querySelector(`[data-block-id="${blockId}"]`);
  if (tabButton) {
    tabButton.click();
  }
});

function initCollectionTabs() {
  const containers = document.querySelectorAll('.custom-collection-tabs-container');

  containers.forEach(container => {
    const tabs = container.querySelectorAll('.custom-collection-tabs__tab');
    const panels = container.querySelectorAll('.custom-collection-tabs__panel');
    const exploreBtn = container.querySelector('.custom-collection-tabs__explore-btn');

    if (!tabs.length) return;

    tabs.forEach(tab => {
      // Avoid double listeners
      if (tab.dataset.listenerAttached) return;
      tab.dataset.listenerAttached = 'true';

      tab.addEventListener('click', () => {
        const index = tab.getAttribute('data-index');
        const collectionUrl = tab.getAttribute('data-collection-url');

        // Deactivate all tabs in this container
        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        // Activate clicked tab
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        // Deactivate all panels in this container
        panels.forEach(p => {
          p.classList.remove('is-active');
        });

        // Activate matching panel
        const targetPanel = container.querySelector(`.custom-collection-tabs__panel[data-index="${index}"]`);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }

        // Dynamically update the explore button URL and text
        if (exploreBtn && collectionUrl) {
          exploreBtn.setAttribute('href', collectionUrl);
          const textSpan = exploreBtn.querySelector('span');
          if (textSpan) {
            textSpan.textContent = `View all in ${tab.textContent.trim()}`;
          }
        }
      });
    });
  });
}
